import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { useBillingStatus } from "@/features/billing/hooks/useBillingStatus";
import { PLAN_LINK_VIEW } from "@/features/billing/planCopy";

export function DashboardStatusStrip({
  exportsInProgress,
}: {
  exportsInProgress: number;
}) {
  const { status } = useBillingStatus();
  const showTrial = Boolean(status?.trial_active && !status.subscribed);
  const showProgress = exportsInProgress > 0;

  if (!showTrial && !showProgress) return null;

  return (
    <div className="dashboard-status-strip">
      {showProgress ? (
        <Link to={ROUTES.exports} className="dashboard-status-item">
          <span className="dashboard-status-value tabular-nums">
            {exportsInProgress}
          </span>
          <span className="dashboard-status-label">
            export{exportsInProgress === 1 ? "" : "s"} in progress
            <span className="dashboard-status-hint">View Export History</span>
          </span>
        </Link>
      ) : null}
      {showTrial ? (
        <Link
          to={ROUTES.billing}
          className="dashboard-status-item dashboard-status-item--trial"
        >
          <span className="dashboard-status-value tabular-nums">
            {status?.trial_days_left ?? 0}
          </span>
          <span className="dashboard-status-label">
            trial days left
            <span className="dashboard-status-hint">{PLAN_LINK_VIEW}</span>
          </span>
        </Link>
      ) : null}
    </div>
  );
}
